import React from 'react';
import './style.scss';
import {Coins} from '../../../../components';

export const GameCoins = ({coins}) => {
  return <div className="app-game-coins"><Coins coins={coins} big={true}/></div>
}
